import { DispositionReasonType, DispositionSpecificationType } from '@/api/apis/case';
import { dispositionReasonsNames, dispositionSpecificationNames } from '@/constants/case/case.constants';
import { BaseEvent } from './BaseEvent';

export type BaseEventWithReasonProps = {
  shared?: boolean;
  event: string;
  description?: string;
  dispositionReason?: DispositionReasonType;
  dispositionSpecification?: DispositionSpecificationType;
  onShareClick?: () => void;
};

export const BaseEventWithReason = ({
  shared,
  event = 'Event',
  description,
  dispositionReason,
  dispositionSpecification,
  onShareClick,
}: BaseEventWithReasonProps) => {
  const isDispositionSpecification =
    dispositionSpecification !== DispositionSpecificationType.None && dispositionSpecification;

  return (
    <div className="flex flex-col gap-1 w-full">
      <BaseEvent event={event} shared={shared} onShareClick={onShareClick} />
      <div>
        {dispositionReason && (
          <div className="text-s-r text-danger-5">
            {dispositionReasonsNames[dispositionReason]}
            {isDispositionSpecification && ':'}
          </div>
        )}
        {isDispositionSpecification && (
          <div className="text-s-r text-danger-10">{dispositionSpecificationNames[dispositionSpecification]}</div>
        )}
      </div>
      {description && (
        <div className="text-s-r text-danger-5 py-1 px-2 bg-danger-80 rounded text-wrap mt-0.5">{description}</div>
      )}
    </div>
  );
};
